import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import Login from './features/auth/Login'
import Logout from './features/auth/Logout'
import Dashboard from './pages/Dashboard'
import PrivateRoute from './components/PrivateRoute'
import Unauthorized from './pages/Unauthorized'
import './App.css'

// Full-screen overlay shown the moment a logout is initiated, and remains
// visible until the browser navigates away to AAD. Prevents an intermediate
// route (e.g. /login from PrivateRoute, or the /logout landing page) from
// flashing in between.
const LogoutOverlay = () => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
      zIndex: 10000,
    }}
  >
    <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} size="large" />
    <div style={{ marginTop: 20, fontSize: 16, fontWeight: 500 }}>Application Tracker</div>
    <div style={{ marginTop: 6, fontSize: 13, color: '#666' }}>Signing you out...</div>
  </div>
)

function App() {
  const isLoggingOut = useSelector((state) => state.auth.isLoggingOut)

  if (isLoggingOut) {
    return <LogoutOverlay />
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route
        path="/dashboard"
        element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        }
      />
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  )
}

export default App
